import { Link, NavLink, Outlet, useLocation } from 'react-router-dom'
import './Relay.css'

function RelayDashboard() {
  return (
    <div className="relay-dashboard">
      {/* Inactive State */}
      <div className="inactive-state">
        <div className="inactive-icon">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
          </svg>
        </div>
        <h2 className="inactive-title">Chat & Support is not active</h2>
        <p className="inactive-description">
          Add live chat to your websites, manage customer conversations, and provide world-class support with Relay.
        </p>
        
        <div className="features-grid">
          <div className="feature-item">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
            </svg>
            <div>
              <span className="feature-title">Live Chat Widget</span>
              <span className="feature-desc">Embed chat on your Studio sites instantly</span>
            </div>
          </div>
          <div className="feature-item">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="2" y="4" width="20" height="16" rx="2"/>
              <path d="M7 15h10"/>
              <path d="M7 11h10"/>
              <path d="M7 7h6"/>
            </svg>
            <div>
              <span className="feature-title">Unified Inbox</span>
              <span className="feature-desc">All conversations in one place</span>
            </div>
          </div>
          <div className="feature-item">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10"/>
              <polyline points="12 6 12 12 16 14"/>
            </svg>
            <div>
              <span className="feature-title">Automations</span>
              <span className="feature-desc">Auto-replies and chatbots</span>
            </div>
          </div>
          <div className="feature-item">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="1" y="4" width="22" height="16" rx="2"/>
              <line x1="1" y1="10" x2="23" y2="10"/>
            </svg>
            <div>
              <span className="feature-title">Payment Context</span>
              <span className="feature-desc">See customer payment history in chat</span>
            </div>
          </div>
        </div>

        <div className="pricing-info">
          <div className="pricing-header">
            <span className="pricing-label">Pricing</span>
            <span className="pricing-badge">Flat rate</span>
          </div>
          <div className="pricing-details">
            <div className="pricing-item">
              <span>Starter</span>
              <span>$19/month</span>
            </div>
            <div className="pricing-item">
              <span>Team</span>
              <span>$49/month</span>
            </div>
            <div className="pricing-item">
              <span>Unlimited chats</span>
              <span>Included</span>
            </div>
          </div>
        </div>

        <button className="btn btn-primary btn-large">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M5 12h14"/>
            <path d="M12 5v14"/>
          </svg>
          Activate Relay
        </button>

        <p className="activate-note">
          Works seamlessly with Studio sites. Add chat to all your websites with one click.
        </p>
      </div>
    </div>
  )
}

function Relay() {
  const location = useLocation()
  const isOverview = location.pathname === '/dashboard/relay'

  const subRoutes = [
    { name: 'Overview', path: '/dashboard/relay', end: true },
    { name: 'Inbox', path: '/dashboard/relay/inbox' },
    { name: 'Widgets', path: '/dashboard/relay/widgets' },
    { name: 'Contacts', path: '/dashboard/relay/contacts' },
    { name: 'Automations', path: '/dashboard/relay/automations' }
  ]

  return (
    <div className="relay-page">
      {/* Header */}
      <div className="page-header">
        <div className="header-info">
          <div className="module-badge relay inactive">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
            </svg>
          </div>
          <div>
            <h1 className="page-title">Chat & Support</h1>
            <p className="page-subtitle">Relay · Customer communication platform</p>
          </div>
        </div>
        <div className="header-badge inactive">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
          </svg>
          Module not active
        </div>
      </div>

      {/* Sub Navigation (disabled) */}
      <nav className="sub-nav disabled">
        {subRoutes.map(route => (
          <span key={route.path} className="sub-nav-link disabled">
            {route.name}
          </span>
        ))}
      </nav>

      {/* Content */}
      {isOverview ? <RelayDashboard /> : <Outlet />}
    </div>
  )
}

export default Relay
